import { render, staticRenderFns } from "./VistoriasDetalhes.vue?vue&type=template&id=4f55faad&scoped=true"
import script from "./VistoriasDetalhes.vue?vue&type=script&lang=js"
export * from "./VistoriasDetalhes.vue?vue&type=script&lang=js"
import style0 from "./VistoriasDetalhes.vue?vue&type=style&index=0&id=4f55faad&prod&scoped=true&lang=scss"
import style1 from "./VistoriasDetalhes.vue?vue&type=style&index=1&id=4f55faad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f55faad",
  null
  
)

export default component.exports